/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![SettingsCircleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACAUlEQVR4nM1VsW7UQBC1RIEUEQj8AL9AImFHstNb3O7OmGhv546CCn4jBUKiBpRfoSEkoYYuoPjoIuiBpEgDQc9nE9+d1767UDDSNLuz82bmzcwGwf8g1tprmuSzYTmHapZPOPtnAESP1wzLRV2ttbeWcvbg4fCuZnmv2T2tzoyR9WkAnFX3sNUsh3g7h3P3rXTy25DsmqwvhuTjNIBm96G82y1sx+dfW0EQxUykvKCSO/ACGJYntWgWVk3uF3y0lkmTe718Bu5l0CVEzs3WW04UDbaNMatQRQPWLMcNdv1Gp+jpXm94W2X9jWlCNcuJtfbO9BvY426GeCPruJuYEwyOL21Fg20vZ5mzLeU6qpN77jU0ZtUHkKaPbnoJZ/l5ZQAIZgGlBViapteJhvcMy45heXtpxO6opUQcXFUqkoFeEDWZ6jHufG+/hFuUh/HBKIrPoHmY7I82Y+0FK8a/oU1N5izKULfNw+TFKEoumjV+3gww3i3+aWUZVJH7nZd6P1ETzrEVu1aFyvob4+hRlnaAPEreLbzsrLU3YDsK49PODMLkslUhWLVYuX8XF8kr1L5OvFJqZV6APEp++D6cw/pWVFghJQA6rSR4vzODKN4Llvgyd4oMNmPdmUG41ZsLAHOCYdQk3w25N9U5WrGl/s/mct4laEV0S8FJwUu8V4/8D/knddORwd2QAAAAAElFTkSuQmCC)
 */
export const SettingsCircleIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = tokens.colors.STATUS_DANGER,
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="19"
        cy="19"
        r="5"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.92 2.08c-.07-.45.18-.93.64-.99a11.1 11.1 0 0 1 2.88 0c.46.06.7.54.64.99-.18 1.16.19 2.2.98 2.53.8.33 1.79-.14 2.49-1.1.27-.36.78-.52 1.14-.24.77.59 1.45 1.27 2.04 2.04.28.36.12.87-.24 1.14-.96.7-1.43 1.7-1.1 2.49.33.8 1.37 1.16 2.53.98.45-.07.93.18.99.64a11.1 11.1 0 0 1 .08 1.82c0 .38-.43.58-.77.4a6.97 6.97 0 0 0-5.63-.35c-.28.1-.59-.14-.59-.43a4 4 0 1 0-4 4c.3 0 .53.31.43.59a6.99 6.99 0 0 0 .35 5.63c.18.34-.02.76-.4.77a11.39 11.39 0 0 1-1.82-.08c-.46-.06-.7-.54-.64-.99.18-1.16-.19-2.2-.98-2.53-.8-.33-1.79.15-2.49 1.1-.27.36-.78.52-1.14.24a11.06 11.06 0 0 1-2.04-2.04c-.28-.36-.12-.87.24-1.14.96-.7 1.43-1.7 1.1-2.49-.33-.8-1.37-1.16-2.53-.98-.45.07-.93-.18-.99-.64a11.1 11.1 0 0 1 0-2.88c.06-.46.54-.7.99-.64 1.16.18 2.2-.19 2.53-.98.33-.8-.14-1.79-1.1-2.49-.36-.27-.52-.78-.24-1.14.59-.77 1.27-1.45 2.04-2.04.36-.28.87-.12 1.14.24.7.95 1.7 1.43 2.49 1.1.8-.33 1.16-1.37.98-2.53Z"
        className={colorClass}
      />
    </svg>
  );
};
